import type { AxiosProgressEvent } from 'axios';
import { useMutation } from 'react-query';

import { axiosInstance } from '@/axios';

export const useUploadFile = () => {
  return useMutation(
    ({
      uploadUrl,
      file,
      headers = {},
      metadataFields = {},
      signal,
      onUploadProgress,
    }: PayloadData) => {
      const method =
        import.meta.env.VITE_CLOUD_PROVIDER === 'azure' ? 'PUT' : 'POST';

      let requestBody;
      if (import.meta.env.VITE_CLOUD_PROVIDER === 'azure') {
        requestBody = file;
      } else {
        const formData = new FormData();
        Object.entries(metadataFields).forEach(([key, value]) => {
          formData.append(key, value as string);
        });
        formData.append('file', file);
        requestBody = formData;
      }

      return axiosInstance.request({
        url: uploadUrl,
        method,
        data: requestBody,
        headers: {
          ...headers,
          'Content-Type': file.type,
        },
        signal,
        onUploadProgress,
      });
    }
  );
};

type PayloadData = {
  uploadUrl: string;
  file: File;
  metadataFields: Record<string, unknown>;
  headers?: Record<string, string>;
  signal?: AbortSignal;
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
};
